/**
 * Merker "gerade frisch angemeldet" wie in der Content-Factory (lib/auth/gerade-angemeldet.ts):
 * die Anmeldeseite setzt ihn, die Shell liest ihn GENAU EINMAL und zeigt dann den
 * Willkommensdialog. In `sessionStorage`, damit ein Neuladen ihn nicht noch einmal ausloest
 * und ein neuer Tab ohne Anmeldung ihn nicht sieht. Gesperrter Speicher ist kein Absturzgrund:
 * der Dialog bleibt dann einfach aus.
 */
const SCHLUESSEL = 'awf-gerade-angemeldet';

export function merkeGeradeAngemeldet(): void {
  try {
    sessionStorage.setItem(SCHLUESSEL, '1');
  } catch {
    // siehe oben
  }
}

export function konsumiereGeradeAngemeldet(): boolean {
  try {
    const gesetzt = sessionStorage.getItem(SCHLUESSEL) === '1';
    if (gesetzt) sessionStorage.removeItem(SCHLUESSEL);
    return gesetzt;
  } catch {
    return false;
  }
}
